import { isZh } from "../utils/language";
import AgendaAttributeConfigModal from "./AgendaAttributeConfigModal";

export default function AgendaBookModals({

  showSaveModal,
  showLoadModal,
  showAttrModal,

  setShowSaveModal,
  setShowLoadModal,
  setShowAttrModal,

  templates,
  selectedTemplateId,
  setSelectedTemplateId,

  templateZh,
  setTemplateZh,
  templateId,
  setTemplateId,

  saveMode,
  setSaveMode,

  handleSaveTemplate,
  handleLoadTemplate,

  agendaBook,
  selectedAgenda,
  id,
	reloadAgendaBook
}) {

  return (
    <>
			{showSaveModal && (
				<div className="modal-overlay">
					<div className="modal-content clean-modal">

						<h3>{isZh() ? "保存範本" : "Save Template"}</h3>

						<div className="form-row">
							<label>{isZh() ? "操作方式" : "Mode"}</label>
							<select
								value={saveMode}
								onChange={(e) => setSaveMode(e.target.value)}
							>
								<option value="new">
									{isZh() ? "新增範本" : "Save as New"}
								</option>
								<option value="replace">
									{isZh() ? "覆蓋現有範本" : "Replace Existing"}
								</option>
							</select>
						</div>

						{saveMode === "new" && (
							<>
								<div className="form-row">
									<label>Nama Mandarin</label>
									<input
										value={templateZh}
										onChange={(e) => setTemplateZh(e.target.value)}
									/>
								</div>

								<div className="form-row">
									<label>Nama Indonesia</label>
									<input
										value={templateId}
										onChange={(e) => setTemplateId(e.target.value)}
									/>
								</div>
							</>
						)}

						{saveMode === "replace" && (
							<div className="form-row">
								<label>{isZh() ? "選擇範本" : "Select Template"}</label>
								<select
									value={selectedTemplateId}
									onChange={(e) => setSelectedTemplateId(e.target.value)}
								>
									<option value="">
										{isZh() ? "請選擇範本" : "Pilih template"}
									</option>
									{templates.map((t) => (
										<option key={t.documentId} value={t.documentId}>
											{t.subject_zh} / {t.subject_id}
										</option>
									))}
								</select>
							</div>
						)}

						<div className="modal-actions">
							<button
								className="btn btn-secondary"
								onClick={() => setShowSaveModal(false)}
							>
								{isZh() ? "取消" : "Cancel"}
							</button>

							<button
								className="btn btn-primary"
								onClick={handleSaveTemplate}
							>
								{isZh() ? "保存" : "Save"}
							</button>
						</div>

					</div>
				</div>
			)}

			{showLoadModal && (
				<div className="modal-overlay">
					<div className="modal-content clean-modal">

						<h3>{isZh() ? "載入範本" : "Load Template"}</h3>

						<div className="form-row">
							<label style={{ display:"none"}}>{isZh() ? "選擇範本" : "Select Template"}</label>
							<select
								value={selectedTemplateId}
								onChange={(e) => setSelectedTemplateId(e.target.value)}
							>
								<option value="">
									{isZh() ? "請選擇範本" : "Pilih template"}
								</option>
								{templates.map((t) => (
									<option key={t.documentId} value={t.documentId}>
										{t.subject_zh} / {t.subject_id}
									</option>
								))}
							</select>
						</div>

						<div className="modal-actions">
							<button
								className="btn btn-secondary"
								onClick={() => setShowLoadModal(false)}
							>
								{isZh() ? "取消" : "Cancel"}
							</button>

							<button
								className="btn btn-primary"
								onClick={handleLoadTemplate}
							>
								{isZh() ? "載入" : "Load"}
							</button>
						</div>

					</div>
				</div>
			)}

			<AgendaAttributeConfigModal
				open={showAttrModal}
				onClose={(reload) => {
					setShowAttrModal(false);

					if (reload) {
						reloadAgendaBook();
					}
				}}
				agendaId={id}
				agenda={selectedAgenda}
				agendaBook={agendaBook}
			/>   
    </>
  );
}